import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthHelper } from '@cation/core/auth/auth-helper';
import { ThemeService } from '@cation/core/services/theme/theme.service';
import { faGamepad, faUsers, faChartLine, faTrophy, faCog, faRocket } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  public isDark = false;

  // Icons
  public faGamepad = faGamepad;
  public faUsers = faUsers;
  public faChartLine = faChartLine;
  public faTrophy = faTrophy;
  public faCog = faCog;
  public faRocket = faRocket;

  private _onDestroy = new Subject<void>();

  constructor(
    public auth: AuthHelper,
    private themeService: ThemeService
  ) {}

  ngOnInit() {
    // Initialize theme
    if (this.auth.userProfile?.cognitoId) {
      this.isDark = this.themeService.isDarkMode(this.auth.userProfile.cognitoId);
    }

    // Watch for theme changes
    this.watchThemeChanges();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private watchThemeChanges() {
    const observer = new MutationObserver(() => {
      if (this.auth.userProfile?.cognitoId) {
        const newIsDark = this.themeService.isDarkMode(this.auth.userProfile.cognitoId);
        if (this.isDark !== newIsDark) {
          this.isDark = newIsDark;
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    this._onDestroy.subscribe(() => observer.disconnect());
  }
}